<ng-container *ngIf="tags && tags.length > 0">
  <span *ngFor="let tag of tags; let l = last">
    <span class="status-pill inline-block mb-1 mr-2" [style.background-color]="tag.color">{{
      tag.label
    }}</span>
    <span class="print-only-inline" *ngIf="!l">,</span>
  </span>
</ng-container>
